import { type ComponentType, useLayoutEffect, useRef } from 'react';
import {
  ListView as KendoListView,
  type ListViewItemProps as KendoListViewItemProps,
} from '@progress/kendo-react-listview';
import type { ListViewProps } from './list-view.types.ts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import styles from './list-view.module.scss';

export function ListView<T>({ data, className, item, emptyClassName, emptyMessage }: ListViewProps<T>) {
  const containerRef = useRef<HTMLDivElement>(null);
  const scrollTopRef = useRef<number | null>(null);

  useLayoutEffect(() => {
    if (containerRef.current) {
      if (scrollTopRef.current !== null) {
        containerRef.current.scrollTop = scrollTopRef.current;
      }
      scrollTopRef.current = containerRef.current.scrollTop;
    }
  });

  const handleScroll = () => {
    if (containerRef.current) {
      scrollTopRef.current = containerRef.current.scrollTop;
    }
  };

  return (
    <div ref={containerRef} className={`${styles.container} ${className}`} onScroll={handleScroll}>
      {data.length > 0 ? (
        <KendoListView data={data} item={item as ComponentType<KendoListViewItemProps>} />
      ) : (
        emptyMessage && (
          <div className={`${styles.emptyList} ${emptyClassName}`}>
            <FontAwesomeIcon size={'lg'} style={{ marginRight: 8 }} icon={faWarning} />
            <span>{emptyMessage}</span>
          </div>
        )
      )}
    </div>
  );
}
